export default "__VITE_ASSET__AOUC$$92__"